var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirektAufRost = function SvgDirektAufRost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Direkt_auf_Rost_svg__Ebene_2",
    viewBox: "0 0 114.07 86.83"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Direkt_auf_Rost_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.3px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Direkt_auf_Rost_svg__Layer_1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.69,
    cy: 74.89,
    r: 8.15,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.38,
    cy: 61.04,
    r: 5.94,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.25,
    cy: 78.63,
    r: 7.05,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.27,
    cy: 61.24,
    r: 4.62,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.83,
    cy: 55.47,
    r: 8.15,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.74,
    cy: 55.01,
    r: 7.05,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.38,
    cy: 76.62,
    r: 4.62,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.67,
    cy: 77.38,
    r: 7.05,
    className: "Direkt_auf_Rost_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.12 59.43 3.2 30.63 58 1.71l52.92 29.8z",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10
    }
  })));
};
export default SvgDirektAufRost;